/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// components
import ServiceHeaderComponents from "../../components/services/headerComponents";
import ServiceFeaturesComponents from "../../components/services/featuresComponents";
import ServiceTeamsComponents from "../../components/services/teamsComponents";
import ServicePackagesComponents from "../../components/services/packagesComponents";
export default function Services() {
  return (
    <div>
      <div className={`services`}>
        <div className={`services_content`}>
          <ServiceHeaderComponents />
          <ServiceFeaturesComponents />
          <ServiceTeamsComponents />
          <ServicePackagesComponents />
        </div>
      </div>
    </div>
  );
}
